'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from '@enlighten/design-system/dist/Grid';
import { useTheme } from '@enlighten/design-system/dist/styles';
import useMediaQuery from '@enlighten/design-system/dist/useMediaQuery';
import { AnimatePresence, motion, useInView } from 'motion/react';
import Image from 'next/image';
import { useRef } from 'react';
import KingSymbol from '../../assets/images/king/symbol.png';
import KingSymbolShadow from '../../assets/images/king/symbol_shadow.png';
export default function KingSection2() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsx(Grid, { container: true, justifyContent: "center", sx: {
            marginBottom: { xs: '130px', md: 0 },
            height: { xs: 165.33, md: 546.8 },
            img: {
                height: 'auto',
            },
            '.symbol': {
                marginTop: { xs: '25px', md: '150px' },
                width: { xs: 100, md: 240 },
            },
            '.symbol-shadow': {
                position: 'absolute',
                marginTop: { xs: '-150px', md: '-370px' },
                width: { xs: 120, md: 300 },
            },
        }, children: _jsx("div", { ref: ref, children: _jsx(AnimatePresence, { children: isInView && (_jsxs(_Fragment, { children: [_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 1 }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                                process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { className: "symbol", src: KingSymbol, alt: "king symbol" })) : (_jsx("img", { className: "symbol", src: KingSymbol, alt: "king symbol" })) }), _jsx(motion.div, { initial: { opacity: 0, x: 0, y: isMobile ? -20 : -50 }, animate: { opacity: 1, x: isMobile ? 30 : 60, y: 0 }, transition: { delay: 0.5, duration: 1 }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                                process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { className: "symbol-shadow", src: KingSymbolShadow, alt: "king symbol shadow" })) : (_jsx("img", { className: "symbol-shadow", src: KingSymbolShadow, alt: "king symbol shadow" })) })] })) }) }) }));
}
